import { hasCapability, type User } from "../base";

export const viewList = {
  read: (user: User) => hasCapability(user, "viewList.read"),
};
